const strings = {
  UNAUTHORIZED_HEADER: 'Email och lösendord matchar ej.',
  UNAUTHORIZED:
    'Email och lösenord matchar ej, observera att detta är inloggningsportalen endast för dig som är administratör för din förening.',
  OK: 'Okej',
  INTERNAL_ERROR_HEADER: 'Något gick fel',
  INTERNAL_ERROR: 'Ett oväntat fel har uppstått, var god försök igen.'
}

export default strings



// WEBPACK FOOTER //
// ./src/components/actions/strings.js